import { FC } from 'react'
import {
    Outlet
} from "react-router-dom";


const ApprovPage: FC = () => {  
    return (
        <Outlet />
    );
}

export default ApprovPage